import SoftcatalaEditor from "./components/Editor";
import './App.css';
import { LanguageToolProvider } from "./hooks/LanguageTool";
import { ParaphraseProvider } from "./model/paraphrase/hooks/ParaphraseContext";
import { getStorageItem, setStorageItem } from "./utils/localStorage";

const initialContent = "Aquests frases servixen per a probar algun de les errades que detecta el corrector gramaticals. Proveu les variants de flexió verbal: penso, pense, pens. L'accentuació valenciana o general: café o cafè. Paraules errònies segons el context: Et menjaràs tots els canalons? Li va infringir un càstig sever. Errors de sintaxi: la persona amb la que vaig parlar. I algunes altres opcions: Quan es celebrarà la festa? Soc un os bru que menja mores. Sóc un ós bru que menja móres."

const App = () => {

  const firstVisit = getStorageItem({ key: 'corrector-first-visit', defaultValue: false })

  let content = ''
  if (firstVisit) {
    content = initialContent
    setStorageItem({ key: 'corrector-first-visit', value: true})
  }

  return (
    <div className="App" style={{ maxWidth: '768px', margin:'auto'}}>
      <LanguageToolProvider>
        <ParaphraseProvider>
          <SoftcatalaEditor initialContent={initialContent} content={content} />
        </ParaphraseProvider>
      </LanguageToolProvider>
    </div>
  );
};

export default App;
